
<Modal
    :show="show"
    size="small"
    :featureAnnouncementLayout="true"
    :closeOnBackdropClick="false"
    @onModalClose="handleClose"
>
    <template #media>
        <div class="FeatureAnnouncementModal-media">
            <div v-if="showPlatformSelector" class="PlatformSelector">
                <button
                    class="PlatformButton"
                    :class="{ 'is-active': selectedPlatform === 'ios' }"
                    @click="selectedPlatform = 'ios'"
                >
                    <i class="ri-apple-line"></i>
                    <span>iOS</span>
                </button>
                <button
                    class="PlatformButton"
                    :class="{ 'is-active': selectedPlatform === 'android' }"
                    @click="selectedPlatform = 'android'"
                >
                    <i class="ri-android-line"></i>
                    <span>Android</span>
                </button>
            </div>
            <VideoPlayer
                v-if="videoSrc"
                :key="videoSrc"
                :src="videoSrc"
                :poster="announcement.videoPoster"
                :title="announcement?.title"
                :autoplay="true"
                :loop="true"
                class="FeatureAnnouncementModal-video"
            />
        </div>
    </template>
    <template #header>
        <span class="FeatureAnnouncementModal-badge">
            <i class="ri-sparkling-2-fill"></i>
            <span>Neu</span>
        </span>
        <h3 class="FeatureAnnouncementModal-title">{{ announcement?.title }}</h3>
    </template>
    <div class="FeatureAnnouncementModal-content">
        <div v-html="announcement?.content"></div>
    </div>

    <template #actions>
        <Button variant="plain" @onClick="handleDismiss" v-if="showDontShowAgain">
            Später ansehen
        </Button>
        <Button variant="success" @onClick="handleDontShowAgain"> Super, danke! </Button>
    </template>
</Modal>
